import { SupportedLanguage } from "./languages";

const APP_STORE_BADGES: Record<SupportedLanguage, string> = {
  en: "download_badge.svg",
  es: "download_badge_es.svg",
  fr: "download_badge_fr.svg",
  de: "download_badge_de.svg",
  ja: "download_badge_jp.svg",
  pl: "download_badge.svg",
  pt: "download_badge.svg",
};

export const getAppStoreBadge = (language: SupportedLanguage): string =>
  APP_STORE_BADGES[language];
